<!-- title -->
<app-modal-title>
  <div header-content class="tw-flex-center">
    <!-- isWarning -->
    <i
      *ngIf="config?.isWarning"
      class="mdi mdi-alert-circle-outline mdi-36px text-warning tw-ml-1"
    ></i>

    <ng-container *ngIf="config?.title; else default">
      <div
        [class]="config?.isWarning ? 'text-warning' : ''"
        class="mat-dialog-title dialog-title tw-text-2xl tw-border-bottom tw-py-2"
      >
        <div class="tw-flex tw-items-center tw-justify-center">
          <span class="tw-font-medium">{{ config?.title | translate }}</span>
        </div>
      </div>
    </ng-container>

    <!-- delete message default -->
    <ng-template #default>
      <div class="tw-text-justify tw-text-2xl dark:tw-text-gray-300">
        <span> {{ "messages.deleteMessage" | translate }}</span>
      </div>
    </ng-template>
  </div>
</app-modal-title>

<div class="tw-min-h-28 tw-flex tw-flex-col tw-justify-center tw-items-center">
  <div class="tw-flex tw-flex-col tw-justify-center tw-px-3 tw-w-full">
    <!-- content -->
    <div
      *ngIf="config?.content && !config?.confirmByWritingText"
      mat-dialog-content
      class="tw-flex-center dialog-content tw-text-xl tw-text-right"
    >
      <div
        *ngIf="config?.isShowChip"
        class="tw-flex tw-items-center tw-flex-wrap"
      >
        <div *ngFor="let chip of chipsValue">
          <span
            class="tw-whitespace-nowrap tw-bg-[#e0e0e0] dark:tw-bg-[#35354c] dark:tw-text-white tw-text-black tw-inline-flex tw-py-2 tw-px-3 tw-rounded-2xl tw-items-center tw-min-h-[32px] tw-h-[1px] tw-m-1"
          >
            {{ chip }}
          </span>
        </div>
      </div>

      <div *ngIf="!config?.isShowChip">
        <!-- text -->
        <div
          *ngIf="!config?.contentToInnerHtml"
          class="tw-text-center"
          [style]="config?.wordBreak ? 'word-break: break-all;' : ''"
        >
          {{ config?.content }}
        </div>
        <!-- inner html -->
        <div
          *ngIf="config?.contentToInnerHtml"
          [style]="config?.wordBreak ? 'word-break: break-all;' : ''"
          [innerHTML]="config?.content"
        ></div>
      </div>
    </div>

    <!-- checkbox -->
    <div
      *ngIf="config?.isShowCheckBox"
      class="form-check tw-flex tw-justify-start tw-items-center tw-mb-2 tw-m-5"
    >
      <input
        type="checkbox"
        class="form-check-input tw-ml-2 tw-mr-0"
        [(ngModel)]="isChecked"
      />
      <span class="tw-font-medium tw-text-gray-900 dark:tw-text-white">{{
        config?.checkBoxLabel | translate
      }}</span>
    </div>

    <!-- confirm By Writing Text -->
    <ng-container *ngIf="config?.confirmByWritingText">
      <div style="max-width: 420px">
        <div class="tw-p-[8px] tw-w-full m-auto">
          <div class="alert alert-danger tw-font-medium">
            <i class="fas fa-exclamation-circle tw-mx-1"></i>
            <span class="tw-font-bold"
              >{{ "common.warning" | translate }} :</span
            >
            <div *ngIf="!config.content">
              {{ "messages.confirmByWritingTextMessage" | translate }}
            </div>
            <div *ngIf="config.content">
              {{ config.content | translate }}
            </div>
          </div>
          <div class="tw-flex flex-column dark:tw-text-gray-300">
            <span class="tw-font-medium">{{
              "messages.confirmText" | translate
            }}</span>
            <span
              copyToClipboard
              class="tw-p-3 bg-light tw-text-center tw-font-medium tw-mt-2 rounded"
              >{{ randomNum }}</span
            >
          </div>
          <div>
            <input
              type="text"
              [maxlength]="4"
              max="4"
              class="form-control tw-mt-2"
              [(ngModel)]="typingText"
            />
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="tw-w-full tw-flex tw-justify-center tw-mb-1 !tw-relative">
    <!-- actions -->
    <mat-dialog-actions class="tw-flex tw-justify-center tw-w-md tw-mb-2">
      <!-- no -->
      <div class="tw-w-1/2 tw-px-1">
        <button
          mat-ripple
          class="btn btn-secondary tw-w-full tw-text-lg tw-font-bold"
          (click)="onClose()"
        >
          <span *ngIf="config?.isConfirmDelete">
            {{ "common.cancel" | translate }}</span
          >
          <span *ngIf="!config?.isConfirmDelete">
            {{ "common.no" | translate }}</span
          >
        </button>
      </div>
      <!-- yes -->
      <div class="tw-w-1/2 tw-px-1">
        <button
          [disabled]="config?.confirmByWritingText && +typingText != randomNum"
          mat-ripple
          class="btn tw-w-full tw-text-lg tw-font-bold tw-flex-center"
          [class]="config?.confirmBtnColor"
          (click)="confirm()"
        >
          <span *ngIf="config?.isConfirmDelete">
            {{ "common.delete" | translate }}</span
          >
          <span *ngIf="!config?.isConfirmDelete">
            {{ "common.yes" | translate }}
            <i class="mdi mdi-check-circle-outline mdi-20px"></i>
          </span>

          <i
            *ngIf="config?.isConfirmDelete"
            class="mdi mdi-trash-can-outline mdi-20px tw-text-base tw-mr-1 tw-mb-1"
          ></i>
          <!-- <i *ngIf="!config?.isConfirmDelete" class="fas fa-check-circle tw-text-base tw-mr-1"></i> -->
        </button>
      </div>
    </mat-dialog-actions>
  </div>
</div>
